import React, { useEffect } from 'react';
import { useCaseId } from '../hooks';
import { useLocation } from 'react-router-dom';

export const BrowserExitPromptActivity = (): React.ReactElement => {
  const { activeCaseId } = useCaseId();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    const handler = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };

    if (activeCaseId) {
      window.addEventListener('beforeunload', handler);
      // clean it up, if the dirty state changes
      return () => {
        window.removeEventListener('beforeunload', handler);
      };
    }

    // since this is not dirty, don't do anything
    return () => {};
  }, [activeCaseId, pathname]);

  return <></>;
};
